'use client';

import { TxParams } from '@drift-labs/sdk';

/**
 * Maps UI's tx params to Vault SDK's tx params format
 */
export const mapTxParamsToVaultTxParams = (txParams: TxParams) => {
	return {
		cuLimit: txParams.computeUnits,
		cuPriceMicroLamports: txParams.computeUnitsPrice,
	};
};
